import { Observable } from "rxjs";
import { DocumentsResponseEntity } from "../../../data/repositories/consult/entities/documents-response.entity";
import { ConsultRepository } from '../../repositories/consult.repository';
import { UseCase } from '../../base/use-case';


export class CreatePendingHCDListByIdUseCase implements UseCase<{ id: string}, DocumentsResponseEntity> {
    constructor(private ConsultRepository: ConsultRepository) { }
    execute(
        params: {id: string},
    ): Observable<DocumentsResponseEntity> {
        return this.ConsultRepository.createPendingHCDListById(params);
    }
}
